"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ArrowLeftCircleIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M11.49-.001c-6.309 0-11.5 5.191-11.5 11.5s5.191 11.5 11.5 11.5 11.5-5.191 11.5-11.5c-.005-6.307-5.193-11.495-11.5-11.5Zm0 20.844c-5.126 0-9.344-4.218-9.344-9.344 0-5.126 4.218-9.344 9.344-9.344 5.126 0 9.344 4.218 9.344 9.344-.003 5.125-4.219 9.341-9.344 9.344Z",
    fill: color
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12.095 16.24a1.042 1.042 0 0 0 0-1.468l-2.243-2.245h5.783c.569 0 1.037-.469 1.037-1.038 0-.569-.468-1.037-1.037-1.037H9.852l2.243-2.246a1.037 1.037 0 0 0-1.468-1.466l-4.013 4.016a1.041 1.041 0 0 0 0 1.467l4.013 4.016a1.04 1.04 0 0 0 1.467 0l.001.001Z",
    fill: color
  })]
});

ArrowLeftCircleIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = ArrowLeftCircleIcon;
exports.default = _default;